export default function WatchedMoviesList({ watched, onDeleteWatched }) {
  return (
    <ul className='list list-movies'>
      {watched.map((movie) => (
        <li key={movie.imdbID}>
          <img src={movie.poster} alt={`${movie.title} poster`} />
          <h3>{movie.title}</h3>
          <div>
            <p>
              <span>⭐️</span>
              <span>{movie.imdbRating}</span>
            </p>
            <p>
              <span>🌟</span>
              <span>{movie.userRating}</span>
            </p>
            <p>
              <span>⏳</span>
              <span>
                {isNaN(movie.runtime) ? 'No Data' : `${movie.runtime} min`}
              </span>
            </p>
            <button
              className='btn-delete'
              onClick={() => onDeleteWatched(movie.imdbID)}
            >
              X
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
}
